var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"foot",attrs:{"id":"foot"}},[(_vm.showLogout)?_c('div',{staticClass:"foot__logo",on:{"click":_vm.logout}},[_vm._v(" Logout ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }